import * as React from 'react'
import styles from './styles.module.css'
import { useSidebarBottomOffset } from './useSidebarBottomOffset'

export function Content({ children }: React.PropsWithChildren) {
  const ref = useSidebarBottomOffset()

  return (
    <div
      ref={ref}
      className={
        styles.content
      }
    >
      {children}
    </div>
  )
}
